import { css, html } from "../helpers/webComponents";
import { GameEventService } from "../services/GameEventService";
import { DefaultPage } from "./RootComponent";

const styles: string = css`
    :host {
        font-family: "Onesize";
        display: block;
        background: #52478b;
        border: 5px solid #332c57;
        padding: 20px;
        width: 1000px;
        height: 650px;
        text-align: center;
        position: relative;
        z-index: 3;
    }

    h2 {
        margin: 10px;
        font-size: 40px;
    }

    p {
        text-align: left;
        font-size: 25px;
    }

    button {
        font-family: "Onesize";
        font-size: 25px;
        background-color: #7f6ed7;
        border: 3px solid #332c57;
        color: white;
        padding: 5px 10px;
        margin: 0;
        text-transform: uppercase;
        cursor: pointer;
        display: inline-block;
        user-select: none;
        width: 50px;
        height: 50px;
        position: absolute;
        top: 10px;
        right: 10px;
    }

    button.active,
    button:hover {
        background-color: #332c57;
    }

`;

export class GameInstructionComponent extends HTMLElement {
    /** Instance of the game event service */
    private readonly _gameEventService: GameEventService = new GameEventService();

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();
    }

    /**
     * Render the contents of this page
     */
    private render(): void {
        if (!this.shadowRoot) {
            return;
        }

        const element: HTMLElement = this.renderInstruction();
        this.shadowRoot.firstChild?.remove();
        this.shadowRoot.append(element);
    }

    private renderInstruction(): HTMLElement {
        // Create template
        const template: HTMLElement = html`
            <div>
                <style>
                    ${styles}
                </style>
                <h2>Game Instructions</h2>
                <p>Welcome to summer breakout student!</p>

                <p>In this game you are trying to escape the summer school that you don't want to attend.</p>

                <p>The goal of the game is for you to explore different rooms within the summer school and discover clues, objects and puzzles. By inspecting rooms and interacting with objects, you can gather important information or find items needed to progress. Some items need to be combined or may come in handy later to unlock a new area.</p>

                <p>You must explore all the rooms until all puzzles are solved and the escape route is found. The challenges range from finding keys to figuring out what the items are used for and also talking with the other remaining people in the building and figuring out what they want.</p>

                <p>That's basically it! Just remember the help we've provided, and you should be good to go. Enjoy the game! ;)</p>
                <button id="back-to-home" class="back-button">X</button>
            </div>
        `;

        template.querySelector("#back-to-home")?.addEventListener("click", e => {
            e.preventDefault();
            this._gameEventService.switchPage(DefaultPage);
        });

        // Return the HTML element
        return template;
    }
}
